module.exports = __webpack_public_path__ + "img/Weapon_243.fda9923b.png";